import { animation, availableAnimations } from "@global/global-animation";
import { shopUtilities } from "@global/shop-utilities/shop-utilities";
import { cookieUtils } from "@utilities/cookie-utils/cookie-utils";

class Quicklinks {
    constructor() {
        this.options = {
            namespace: '',
            quicklinks: 'global-header__quicklinks',
            quicklinkTrigger: 'quicklinks__slide-link',
            quicklinkWrapper: 'quicklinks__triggers',
            quicklinkBack: 'quicklinks__back',
            quicklinkSlide: 'quicklinks__slide',
            elementsToHide: ['main-navigation'],
            quicklinkPresenter: 'quicklinks__presenter',
            navigation: 'navigation',
            mainNavigation: 'main-navigation',
            cart: 'icon--shop',
            wishlist: 'icon--wishlist'
        };

        this.state = {
            namespace: null,
            setNamespace: (stateObject, namespace) => {
                stateObject.namespace = namespace;
            }
        };

        this.actions = {
            visibilitySiblings: (elementArray, visible = false) => {
                if (visible) {
                    elementArray.forEach(element => {
                        const elementToHide = document.querySelectorAll(`${this.state.namespace}.${element}`);
                        elementToHide.forEach(element => {
                            element.style.cssText = '';
                            animation.addAnimation(element, availableAnimations.slides.slideInLeft, null, [

                            ])
                        });
                    });
                } else {
                    elementArray.forEach(element => {
                        const elementToHide = document.querySelectorAll(`${this.state.namespace}.${element}`);
                        elementToHide.forEach(element => {
                            animation.addAnimation(element, availableAnimations.slides.slideOutLeft, null, [
                                {
                                    eventType: 'animationend',
                                    eventCallback: e => {
                                        e.target.style.display = 'none';
                                    }
                                }
                            ])
                        });
                    });
                }
            },
            notification: (element, key, type) => {
                shopUtilities.changed(() => {
                    const cookieValue = cookieUtils.cookieValueLength(key);
                    if (cookieValue) {
                        if (!element.classList.contains('notification')) {
                            element.classList.add('notification');
                        }

                        element.setAttribute('data-value', cookieValue);
                    } else {
                        if (element.classList.contains('notification')) {
                            element.classList.remove('notification');
                        }

                        element.setAttribute('data-value', '');
                    }
                }, true, type);
            }
        };

        this.eventHandler = {
            openQuicklinkSlide: (e) => {
                const trigger = e.target.closest(`.${this.options.quicklinkTrigger}`);
                try {
                    const slide = trigger.nextElementSibling;
                    if (slide.classList.contains(`${this.options.quicklinkSlide}`)) {
                        const triggerWrapper = document.querySelector(`${this.state.namespace}.${this.options.quicklinkWrapper}`);
                        const presenter = document.querySelector(`${this.state.namespace}.${this.options.quicklinkPresenter}`);
                        const quicklinkUnit = document.querySelector(`${this.state.namespace}.${this.options.quicklinks}`);
                        const navigationUnit = document.querySelector(`${this.state.namespace}.${this.options.navigation}`);

                        this.actions.visibilitySiblings(this.options.elementsToHide);

                        const slideClone = slide.cloneNode(true);
                        slideClone.style.display = 'block';
                        presenter.append(slideClone);

                        const quicklinkBackReference = slideClone.querySelector(`.${this.options.quicklinkBack}`);
                        if (quicklinkBackReference !== undefined) {
                            quicklinkBackReference.addEventListener('click', this.eventHandler.closeQuicklinkSlide);
                        }

                        animation.addAnimation(triggerWrapper, availableAnimations.slides.slideOutLeft, null, [
                            {
                                eventType: 'animationend',
                                eventCallback: e => {
                                    e.target.style.display = 'none';
                                }
                            }
                        ]);

                        quicklinkUnit.style.height = `${quicklinkUnit.scrollHeight}px`;
                        navigationUnit.style.height = `${navigationUnit.scrollHeight}px`;
                        presenter.style.display = 'block';
                        animation.addAnimation(presenter, availableAnimations.slides.slideInRight, null, [
                            {
                                eventType: 'animationend',
                                eventCallback: () => {
                                    quicklinkUnit.style.height = `${presenter.scrollHeight}px`;
                                    navigationUnit.style.height = `${presenter.scrollHeight + 30}px`;
                                }
                            }
                        ]);
                    }
                } catch {
                    new Error("Could not find slide to show.")
                }
            },
            closeQuicklinkSlide: () => {
                const triggerWrapper = document.querySelector(`${this.state.namespace}.${this.options.quicklinkWrapper}`);
                const presenter = document.querySelector(`${this.state.namespace}.${this.options.quicklinkPresenter}`);
                const quicklinkUnit = document.querySelector(`${this.state.namespace}.${this.options.quicklinks}`);
                const navigationUnit = document.querySelector(`${this.state.namespace}.${this.options.navigation}`);
                const mainNavigationUnit = document.querySelector(`${this.state.namespace}.${this.options.mainNavigation}`);
                triggerWrapper.style.display = '';
                animation.addAnimation(triggerWrapper, availableAnimations.slides.slideInLeft, null, [
                ]);

                animation.addAnimation(presenter, availableAnimations.slides.slideOutRight, null, [
                    {
                        eventType: 'animationstart',
                        eventCallback: () => {
                            navigationUnit.style.height = `${quicklinkUnit.scrollHeight + mainNavigationUnit.scrollHeight + 30}px`;
                        }
                    },
                    {
                        eventType: 'animationend',
                        eventCallback: e => {
                            e.target.style.cssText = '';
                            e.target.innerHTML = '';
                            quicklinkUnit.style.height = ``;
                        }
                    }
                ]);

                this.actions.visibilitySiblings(this.options.elementsToHide, true);
            }
        };
    }

    init(overwriteOptions) {
        this.options = Object.assign(this.options, overwriteOptions);

        if (this.options.namespace !== '') {
            this.state.setNamespace(this.state, `.${this.options.namespace} `);
        } else {
            this.state.setNamespace(this.state, '');
        }

        const cartIcons = document.querySelectorAll(`.${this.options.cart}`);
        const wishlistIcons = document.querySelectorAll(`.${this.options.wishlist}-empty, .${this.options.wishlist}-filled`);

        cartIcons.forEach(icon => {
            this.actions.notification(icon.parentNode, `cart_${window.market}`, 'cart');
        });

        wishlistIcons.forEach(icon => {
            this.actions.notification(icon.parentNode, `wishlist_${window.market}`, 'wishlist');
        });

        const quicklinkReferences = document.querySelectorAll(`${this.state.namespace}.${this.options.quicklinkTrigger}`);
        if (quicklinkReferences !== undefined) {
            quicklinkReferences.forEach(quicklinkElement => {
                quicklinkElement.addEventListener('click', this.eventHandler.openQuicklinkSlide)
            });
        }
    }
}

class QuicklinkTab {
    constructor() {
        this.options = {
            namespace: '',
            quicklinks: 'global-header__quicklinks',
            quicklinkTrigger: 'quicklinks__slide-link',
            quicklinkWrapper: 'quicklinks__triggers',
            quicklinkBack: 'quicklinks__back',
            quicklinkSlide: 'quicklinks__slide',
            elementsToHide: ['main-navigation'],
            quicklinkPresenter: 'quicklinks__presenter',
            navigation: 'navigation',
            mainNavigation: 'main-navigation',
            cart: 'icon--cart',
            wishlist: 'icon--wishlist'
        };
    }

    init(overwriteOptions) {
        this.options = Object.assign(this.options, overwriteOptions);

        this.state = {
            namespace: null,
            setNamespace: (stateObject, namespace) => {
                stateObject.namespace = namespace;
            }
        };

        if (this.options.namespace !== '') {
            this.state.setNamespace(this.state, `.${this.options.namespace} `)
        } else {
            this.state.setNamespace(this.state, '');
        }

        const quicklinkReferences = document.querySelectorAll(`${this.state.namespace}.${this.options.quicklinkTrigger}`);
        if (quicklinkReferences) {
            const presenter = document.querySelector(`${this.state.namespace}.${this.options.quicklinkPresenter}`);
            quicklinkReferences.forEach(quicklinkElement => {
                quicklinkElement.addEventListener('click', () => {
                    const slide = quicklinkElement.nextElementSibling;
                    if(quicklinkElement.classList.contains("selected")) {
                        quicklinkElement.classList.remove("selected");
                        if (slide.classList.contains(this.options.quicklinkSlide)) {
                            presenter.removeChild(presenter.querySelector(`.${this.options.quicklinkSlide}`));
                        }
                    } else {
                        quicklinkElement.classList.add("selected");
                        if (slide.classList.contains(this.options.quicklinkSlide)) {
                            presenter.style.top = `${quicklinkElement.clientHeight}px`;
                            presenter.innerHTML = '';
                            presenter.appendChild(slide.cloneNode(true));
                        }
                    }
                });
            });

            document.addEventListener("click", (e) => {
                if(!e.target.closest(`${this.state.namespace}.${this.options.quicklinks}`)) {
                    quicklinkReferences.forEach(quicklinkElement => {
                        if (quicklinkElement.classList.contains('selected')) {
                            quicklinkElement.classList.remove('selected');
                            presenter.removeChild(presenter.querySelector(`.${this.options.quicklinkSlide}`));
                        }
                    });
                }
            });
        }
    }
}

export { Quicklinks, QuicklinkTab }
